<template>
	<aside class="iv2-bottom-nav theme-a__bottom-bg position-fixed text-center d-md-none d-lg-none">
		<nav class="iv2-bottom-nav__sub-menu">
			<ul class="iv2-bottom-nav__sub-list list-unstyled">
				<li v-for="nav in bottom" :key="nav.id" class="iv2-bottom-nav__sub-item">
					<router-link
						v-if="nav.link_type == 'internal'"
						:to="nav.link_href"
						@click.native="activeMenu = false"
						class="iv2-bottom-nav__sub-link theme-a__bottom-link"
					>
						<i :class="'iv2-bottom-nav__sub-item-icon d-block ' + nav.item_icon"></i>
						<span class="iv2-bottom-nav__sub-item-text d-block">{{nav.item_name}}</span>
					</router-link>
					<a
						v-else-if="nav.link_type == 'external'"
						v-bind:href="nav.link_href"
						:target="nav.target_type"
						rel="noopener"
						class="iv2-bottom-nav__sub-link theme-a__bottom-link"
					>
						<i :class="'iv2-bottom-nav__sub-item-icon d-block ' + nav.item_icon"></i>
						<span class="iv2-bottom-nav__sub-item-text d-block">{{nav.item_name}}</span>
					</a>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script>
export default {
	props: ["bottom"],
};
</script>

<style lang="scss">
/* SP Only */
@media (max-width: 767px) {
	.iv2-bottom-nav {
		display: block;
		border-left: none;
		-webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		mix-blend-mode: normal;
		padding: 0;

		.iv2-bottom-nav__sub-menu {
			height: 100%;
			.iv2-bottom-nav__sub-list {
				margin-bottom: 0;
				height: 100%;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				align-items: center;
				-ms-flex-pack: distribute;
				justify-content: space-around;

				.iv2-bottom-nav__sub-item {
					margin-bottom: 0;
					display: inline-block;
					width: 65px;

					.iv2-bottom-nav__sub-link {
						-webkit-transition: 0.3s;
						transition: 0.3s;
						vertical-align: middle;
						padding: 0;

						&:hover {
							text-decoration: none;
							opacity: 0.5;
						}
					}

					.iv2-bottom-nav__sub-item-icon {
						margin-bottom: 3px;
						font-size: 1.2rem;
					}

					.iv2-bottom-nav__sub-item-text {
						font-size: 10px;
						font-weight: 400;
						line-height: 1.2;
					}
				}
			}
		}
	}
}
</style>